import { useTranslation } from "react-i18next";

import { useDropDown, useFilterState } from "../../../hooks";

import { WorldIcon } from "../../common/WorldIcon";
import CircleIconFlag from "../CircleIconFlag";

import {
  Item,
  List,
  StyledInput,
  Wrapper,
  WrapperRoot,
} from "./DropDown.styled";

export const DropDown = ({
  search,
  options = [],
  closeSelect,
  top,
  topMobile,
  left,
}) => {
  const { t } = useTranslation();
  const { selectedCountry, setSelectedCountry } = useFilterState();

  const handleSelect = countryName => {
    const selected =
      countryName === t("global.allCountries") ? "" : countryName;
    setSelectedCountry(selected);
    closeSelect();
  };

  const {
    listRef,
    itemRefs,
    inputOptions,
    inputValue,
    highlightedIndex,
    handleInputChange,
    setHighlightedIndex,
  } = useDropDown(options);

  const handleKeyDown = e => {
    switch (e.key) {
      case "ArrowDown":
        setHighlightedIndex(prevIndex =>
          prevIndex === inputOptions.length - 1 ? -1 : prevIndex + 1,
        );
        break;

      case "ArrowUp":
        setHighlightedIndex(prevIndex =>
          prevIndex === -1 ? inputOptions.length - 1 : prevIndex - 1,
        );
        break;

      case "Enter":
        if (highlightedIndex === -1) {
          handleSelect(t("global.allCountries"));
        } else {
          handleSelect(inputOptions[highlightedIndex]?.englishName);
        }
        break;

      default:
        break;
    }
  };

  return (
    <WrapperRoot
      className="dropDown"
      onClick={e => e.stopPropagation()}
      onKeyDown={handleKeyDown}
      top={top}
      topMobile={topMobile}
      left={left}
    >
      {search && (
        <StyledInput
          name="search"
          value={inputValue}
          placeholder={t("freeProxyServer.table.search")}
          onChange={handleInputChange}
          autoFocus
          autoComplete="off"
        />
      )}

      <Wrapper>
        <List ref={listRef} aria-label="countyry list">
          <Item
            ref={el => (itemRefs.current[-1] = el)}
            onClick={() => handleSelect(t("global.allCountries"))}
            isHighlighted={highlightedIndex === -1}
            isGreen={!selectedCountry}
          >
            <WorldIcon />
            {t("global.allCountries")}
          </Item>
          {inputOptions.map(({ id, name, alpha2, englishName }, index) => {
            return (
              <Item
                key={id}
                ref={el => (itemRefs.current[index] = el)}
                onClick={() => handleSelect(englishName)}
                isHighlighted={index === highlightedIndex}
                isGreen={selectedCountry === englishName}
              >
                <CircleIconFlag className={alpha2} />
                {name}
              </Item>
            );
          })}
        </List>
      </Wrapper>
    </WrapperRoot>
  );
};
